import React from "react"
import { toast, cssTransition } from 'react-toastify'
import Avatar from "../../components/@vuexy/avatar/AvatarComponent"
import { Bell, Check, X, AlertTriangle, Info } from 'react-feather'
import 'animate.css/animate.css'

const PrimaryToast = (props) => (
    <React.Fragment>
      <div className='toastify-header'>
        <div className='title-wrapper'>
          <Avatar size='sm' color='primary' icon={<Bell size={12} />} />
          <h6 className='toast-title text-primary'>{props.title}</h6>
        </div>
        {props.time && <small className='text-muted'>{props.time}</small>}
      </div>
      {props.body && <div className='toastify-body'>
        <span role='img' aria-label='toast-text'>
            {props.body}
        </span>
      </div>}
    </React.Fragment>
)
  
const SuccessToast = (props) => (
    <React.Fragment>
      <div className='toastify-header'>
        <div className='title-wrapper'>
          <Avatar size='sm' color='success' icon={<Check size={12} />} />
          <h6 className='toast-title text-success'>{props.title}</h6>
        </div>
        {props.time && <small className='text-muted'>{props.time}</small>}
      </div>
      {props.body && <div className='toastify-body'>
        <span role='img' aria-label='toast-text'>
           {props.body}
        </span>
      </div>}
    </React.Fragment>
)
  
const ErrorToast = (props) => (
    <React.Fragment>
      <div className='toastify-header'>
        <div className='title-wrapper'>
          <Avatar size='sm' color='danger' icon={<X size={12} />} />
          <h6 className='toast-title text-danger'>{props.title}</h6>
        </div>
        {props.time && <small className='text-muted'>{props.time}</small>}
      </div>
      {props.body && <div className='toastify-body'>
        <span role='img' aria-label='toast-text'>
            {props.body}
        </span>
      </div>}
    </React.Fragment>
)
  
const WarningToast = (props) => (
    <React.Fragment>
      <div className='toastify-header'>
        <div className='title-wrapper'>
          <Avatar size='sm' color='warning' icon={<AlertTriangle size={12} />} />
          <h6 className='toast-title text-warning'>{props.title}</h6>
        </div>
        {props.time && <small className='text-muted'>{props.time}</small>}
      </div>
      {props.body && <div className='toastify-body'>
        <span role='img' aria-label='toast-text'>
            {props.body}
        </span>
      </div>}
    </React.Fragment>
)
  
const InfoToast = (props) => (
    <React.Fragment>
      <div className='toastify-header'>
        <div className='title-wrapper'>
          <Avatar size='sm' color='info' icon={<Info size={12} />} />
          <h6 className='toast-title'>{props.title}</h6>
        </div>
        {props.time && <small className='text-muted'>{props.time}</small>}
      </div>
      {props.body && <div className='toastify-body'>
        <span role='img' aria-label='toast-text'>
            {props.body}
        </span>
      </div>}
    </React.Fragment>
)
  
const SuccessProgressToast = (props) => (
    <React.Fragment>
      <div className='toastify-header'>
        <div className='title-wrapper'>
          <Avatar size='sm' color='success' icon={<Check size={12} />} />
          <h6 className='toast-title'>{props.title}</h6>
        </div>
        {props.time && <small className='text-muted'>{props.time}</small>}
      </div>
      {props.body && <div className='toastify-body'>
        <span role='img' aria-label='toast-text'>
            {props.body}
        </span>
      </div>}
    </React.Fragment>
)

const slideFade = cssTransition({
    enter: "animate__animated animate__faster animate__fadeInRight",
    exit: "animate__animated animate__faster animate__fadeOutRight"
});

export class newToast {
    static default = (title, body = null) => toast(<PrimaryToast title={title} body={body} />, { hideProgressBar: true, transition: slideFade })
    static success = (title, body = null) => toast.success(<SuccessToast title={title} body={body} />, { hideProgressBar: true, transition: slideFade })
    static error = (title, body = null) => toast.error(<ErrorToast title={title} body={body} />, { hideProgressBar: true, transition: slideFade })
    static warning = (title, body = null) => toast.warning(<WarningToast title={title} body={body} />, { hideProgressBar: true, transition: slideFade })
    static info = (title, body = null) => toast.info(<InfoToast title={title} body={body} />, { hideProgressBar: true, transition: slideFade })
    static successProgress = (title, body = null) => toast.success(<SuccessProgressToast title={title} body={body} />)
}